/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsControllerFindAllCountQueryResponse,
  TelegramProductsControllerFindAllCountQueryParams,
  TelegramProductsControllerFindAllCount401,
} from '../types/TelegramProductsControllerFindAllCount.ts';

function getTelegramProductsFindAllCountUrl() {
  const res = { method: 'GET', url: `/api/telegram/products/count` as const };
  return res;
}

/**
 * {@link /api/telegram/products/count}
 */
export async function telegramProductsFindAllCount(
  params?: TelegramProductsControllerFindAllCountQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsControllerFindAllCountQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindAllCount401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsFindAllCountUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
